import { MathBase, TextFieldHelper } from "@goodgamestudios/core";
import { TextField } from "@goodgamestudios/createjs-utilities";
import { int } from "@goodgamestudios/math-utilities";
import { Poker2Model } from "../../model/Poker2Model";

import { NumberStringHelper } from "../../helper/NumberStringHelper";

export class PokerTextHelper {
    constructor() {
    }

    /**
     * time in seconds
     * return hours:minutes:secounds
     */
    public static getCountDownTimeString(time: number): string {
        var seconds: number = int(time);
        var minutes: number = int(seconds / 60);
        var hours: number = int(minutes / 60);
        seconds -= int(minutes * 60);
        minutes -= int(hours * 60);

        var result: string = '';
        if (time > 0) {
            if (hours < 10)
                result = '0';
            result += hours + ':';
            if (minutes < 10)
                result += '0';
            result += minutes + ':';
            if (seconds < 10)
                result += '0';
            result += seconds;
            return result;
        } else {
            //TODO  Verstrichene Zeit oder Text ausgeben wenn das Turnier bereits läuft
            return Poker2Model.languageData.getTextById("menu_tournament_inprogress");
        }

    }

    public static getShortGroupNumberString(value: number): string {
        if (value < 1000000)
            return NumberStringHelper.groupString(value, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));

        var mio: number = MathBase.round(value / 1000000, 1);
        if (mio < 1000)
            return Poker2Model.languageData.getTextById("common_million", [mio]);

        var mrd: number = MathBase.round(value / 1000000000, 1);
        return Poker2Model.languageData.getTextById("common_milliard", [mrd]);
    }

    public static writeLabel(textId: string, textField: TextField, fontSize: number = 10, upperCase: boolean = false): void {
        var text: string = Poker2Model.languageData.getTextById(textId);

        // upper case?
        if (upperCase) {
            text = text.toUpperCase();
        }

        TextFieldHelper.changeTextFromatSizeByTextWidth(fontSize, textField, text);
    }
}
